import React, { PureComponent } from 'react'
import {
  Grid,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
} from '@material-ui/core'
import OnFleetShopInfoItem from './OnFleetShopInfoItem'
import EditableHOCWrapper from '../../containers/HOC/EditableHOC'
import { hasAccess } from '../../utils/api'
import { withStyles } from '@material-ui/core/styles'

const useStyles = (theme) => ({
  paper: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
})

const OnFleetShopInfoItemEditable = EditableHOCWrapper(OnFleetShopInfoItem)

class OnFleetShopInfo extends PureComponent {
  constructor(props) {
    super(props)
  }

  render() {
    const {
      shopsList = {},
      hubList = {},
      fetchHubList,
      onSave,
      lastModified,
      onSaveResetOnfleetInfo,
      classes,
    } = this.props
    const { values = [] } = shopsList
    console.log(values, 'values')
    return (
      <div>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Paper className={classes.paper}>
            <div className="table-scroll">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Shop Name</TableCell>
                    <TableCell>Onfleet API Key</TableCell>
                    <Tooltip title="The selected hub in Onfleet">
                      <TableCell>Hub</TableCell>
                    </Tooltip>
                    <Tooltip title="If enabled, allow BLAZE to communicate with Onfleet">
                      <TableCell>Status</TableCell>
                    </Tooltip>
                    {hasAccess() ? <TableCell></TableCell> : null}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(values &&
                    values.length &&
                    values.map((shop, index) => {
                      if (shop.appTarget && shop.appTarget === 'Retail') {
                        return (
                          <OnFleetShopInfoItemEditable
                            key={index}
                            dataToEdit={shop}
                            fetchHubList={fetchHubList}
                            hubList={hubList}
                            isNotLinkedApiKey={!shop.onFleetApiKey ? true : false}
                            onSave={onSave}
                            lastModified={lastModified}
                            onSaveResetOnfleetInfo={onSaveResetOnfleetInfo}
                          />
                        )
                      }
                    })) ||
                    null}
                </TableBody>
              </Table>
            </div>
          </Paper>
        </Grid>
      </div>
    )
  }
}

export default withStyles(useStyles)(OnFleetShopInfo)



// WEBPACK FOOTER //
// ./src/components/OnFleet/OnFleetShopInfo.js